webpackJsonp([199091940537836],{

/***/ 676:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Karneval fällt bei mir dieses Jahr aus, denn die ISE 2016 steht vor der Tür.</p>\n<p>Vom 8.2. bis 12.2.  berichte ich jeden Tag von der Messe. Dieses Jahr ist sie ja um einen Tag verlängert, also bis Freitag geöffnet. Das bedeutet: mehr Highlights, mehr Produkte und mehr persönliche Eindrücke.  Hier können Sie die Infos abrufen und Anregungen und Kommentare hinterlassen. <a href=\"https://www.professional-system.de/business/5-tage-non-stop-ise-blog/\">weiterlesen</a></p>","excerpt":"Karneval fällt bei mir dieses Jahr aus, denn die ISE 2016 steht vor der Tür. Vom 8.2. bis 12.…","frontmatter":{"title":"ISE 2016","date":"February 15, 2016","path":"/ise-2016","image":"/2016-02-15-ise2016.jpg"}}},"pathContext":{"prev":null,"next":{"frontmatter":{"path":"/prolight-and-sound-2016"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---ise-2016-2d0443229c4bc930a88d.js